import { Skeleton } from '@execonline-inc/execonline-ui';

function LicenseInsightsSkeleton() {
  return (
    <div className="w-full mb-4 mt-7">
      <Skeleton variant="text" className="h-5 w-16 mr-4 mb-4" />
      {[...Array(3)].map((_, index) => (
        <div key={index} className="mb-4 p-4 border border-gray-200 rounded-lg">
          <Skeleton variant="text" className="h-4 w-3/4 mb-2" />
          <Skeleton variant="text" className="h-4 w-1/2" />
        </div>
      ))}
    </div>
  );
}

export default LicenseInsightsSkeleton;
